import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class BrowserBackGuardService
{
    private isEnabled = false;

    public enable(): void
    {
        if (this.isEnabled)
        {
            return;
        }

        this.isEnabled = true;
        history.pushState(null, '', location.href);
        window.addEventListener('popstate', this.onPopState);
    }

    private readonly onPopState = (): void =>
    {
        history.pushState(null, '', location.href);
    };
}
